module.exports = __webpack_public_path__ + "img/about-us-team-left-new.407069dc.jpg";